import BannerAdItem from './BannerAdItem';

export default BannerAdItem;
